// extracted by mini-css-extract-plugin
export default {"main":"Fuels_main__wrbAK"};